import * as React from "react";
import DataGrid, { Column, FilterRow, HeaderFilter } from "devextreme-react/data-grid";
import { ExpenseCategoryLabel } from 'src/services/Enum/ExpenseCategoryEnum';
import { MoneyMask } from 'src/util/Masks/MoneyMask';
import { IExpenseItem } from 'src/services/interfaces/Expense/IExpenseItem';
import { formatDateTime } from 'src/util/Date.helper';

interface IViewExpenseItemsTableProps {
  expenseItems: IExpenseItem[];
  loading: boolean;
}

export const ViewExpenseItemsTable: React.FC<IViewExpenseItemsTableProps> = ({
  expenseItems,
  loading
}) => {
  const moneyMask = ({ value }) => MoneyMask(value!);

  return (
    <DataGrid
      dataSource={expenseItems}
      allowColumnReordering
      showBorders
      loadPanel={{ enabled: loading }}
      rowAlternationEnabled
      hoverStateEnabled
      columnAutoWidth
    >
      <FilterRow visible />
      <HeaderFilter visible />
      <Column caption="Id do Trade" alignment="center" dataField="trade.id" dataType="number" />
      <Column caption="Valor" alignment="center" dataField="value" dataType="number" cellRender={moneyMask} />
      <Column caption="Categoria" alignment="center" dataField="category" dataType="string" width="auto"
        cellRender={(params: any) =>
          <p>{ExpenseCategoryLabel.get(params.data.category)}</p>
        }
      />
      <Column caption="Data de Última Atualização" dataField="lastUpdate" alignment="center" dataType="dateTime" cellRender={(params) => formatDateTime(params.data.lastUpdate)} />
      <Column caption="Data de Criação" alignment="center" dataField="createdDate" dataType="date" format="dd/MM/yyyy" />
    </DataGrid>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/Details/ViewExpenseItemsTable/ViewExpenseItemsTable.tsx